import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";

// Highlighting links when scrolled to

export default class StickyNavBehaviour extends AbstractDataAttributeBehaviour {
    attrNames = {
        'container': 'data-sticky-nav-container',
        'section': 'data-sticky-nav-section',
        'button': 'data-sticky-nav-button',
        'offset': 'data-sticky-offset'
    };

    getContainerSelector()
    {
        return '[' + this.attrNames.container + ']';
    }

    onScroll (container, scrollTriggerOffset, buttons) {
        for ( let i = 0; i < buttons.length; i++ ) {
            let sectionQuery = buttons[i].getAttribute(this.attrNames.button);
            let section = document.querySelector('['+this.attrNames.section+'="'+ sectionQuery+'"]');
            let stickyOffset = container.classList.contains('stick-to-top') ? container.clientHeight : container.clientHeight * 2;
            // let stickyOffset = 0;
            if ( window.pageYOffset >= (section.offsetTop -  stickyOffset) && window.pageYOffset < (section.offsetTop + section.clientHeight) - stickyOffset) {
                buttons[i].classList.add('active');
            } else {
                buttons[i].classList.remove('active')
            }
        }

        window.pageYOffset > scrollTriggerOffset ? container.classList.add('stick-to-top') : container.classList.remove('stick-to-top');
    }

    initContainer(container)
    {
        let buttons = document.querySelectorAll('['+this.attrNames.button+']');
        let scrollTriggerOffset = container.offsetTop;
        window.addEventListener('scroll', () => { this.onScroll(container, scrollTriggerOffset, buttons) });
    }
}